import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=47f356f8&"
import script from "./editform.vue?vue&type=script&lang=js&"
export * from "./editform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports